<div class="modal">
    <div class="modal-header">
        <h3 mat-dialog-title>{{ data.title }}</h3>

        <button mat-icon-button aria-label="Close modal" (click)="dialog.closeAll()">
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 1L1 22M1 1L22 22" stroke="black" />
            </svg>
        </button>
    </div>
    <div class="modal-content" mat-dialog-content [innerHTML]="data.content | markdown: {html: true}"></div>
</div>
